import { IPermissionDTO, ICategoryPermission, EPermissionLevel } from "../interfaces/ICategoryPermission";

const PermissionMapper = {
    permissionLevelToDomain: (v: string): EPermissionLevel => {
        switch (v) {
            case "vain_julkiset":
                return EPermissionLevel.OnlyPublic;
            case "aina":
                return EPermissionLevel.Always;
            case "ei_koskaan":
            default:
                return EPermissionLevel.Never;
        }
    },
    permissionsToDomain: (permissions: IPermissionDTO[]): ICategoryPermission[] => {
        return permissions.map((perm): ICategoryPermission => ({
            id: perm.id,
            categoryId: perm.kategoria,
            roleId: perm.rooli,
            create: PermissionMapper.permissionLevelToDomain(perm.lisays),
            edit: PermissionMapper.permissionLevelToDomain(perm.muokkaus),
            read: PermissionMapper.permissionLevelToDomain(perm.luku),
        }));
    },
    // permissionsToDomain: (roles: IAppRoleDTO[], permissions: IPermissionDTO[]): IPermissionsToDomainResult => {
    //     const groupedByCategory = _groupBy(permissions, "categoryId");

    //     return _mapValues(groupedByCategory, (perms, categoryId): ICategoryPermission => {
    //         const maxPermissionRead = _maxBy(perms, (perm) => PermissionMapper.permissionLevelToDomain(perm.luku));
    //         const maxPermissionUpdate = _maxBy(perms, (perm) => PermissionMapper.permissionLevelToDomain(perm.muokkaus));
    //         const maxPermissionCreate = _maxBy(perms, (perm) => PermissionMapper.permissionLevelToDomain(perm.lisays));

    //         return {
    //             id: 1,
    //             categoryId: categoryId as any as number, // _mapValues types the key as string, but we know it's a number
    //             create: PermissionMapper.permissionLevelToDomain(maxPermissionCreate.lisays),
    //             edit: PermissionMapper.permissionLevelToDomain(maxPermissionUpdate.muokkaus),
    //             read: PermissionMapper.permissionLevelToDomain(maxPermissionRead.luku),
    //         };
    //     });
    // },
};

export default Object.freeze(PermissionMapper);
